import { Outlet } from 'react-router-dom';

import { HeaderAdmin } from '@/components/HeaderAdmin';

export function AdminLayout() {
  return (
    <div className="min-h-screen bg-gray-100">
      <HeaderAdmin />

      <main className="container mx-auto overflow-hidden px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}
